import React, { useState } from 'react';
import { FONT_FAMILIES } from '@/data/optionsCore';
import { FONT_MAP } from '@/data/fontMap';

export default function FontPicker({ sampleText, family, style, onPick }) {
  const [activeFamily, setActiveFamily] = useState(family || 'sans-serif');
  const preview = (sampleText && sampleText.trim().slice(0, 18)) || 'Type Elite';
  const fam = FONT_FAMILIES.find((f) => f.id === activeFamily) || FONT_FAMILIES[0];

  return (
    <div className="space-y-3" data-testid="font-picker">
      <div className="flex flex-wrap gap-2" data-testid="font-family-tabs">
        {FONT_FAMILIES.map((f) => (
          <button
            key={f.id}
            data-testid={`ff-${f.id}`}
            onClick={() => setActiveFamily(f.id)}
            className={`chip ${activeFamily === f.id ? 'active' : ''}`}
          >
            {f.label} <span className="opacity-60 ml-1">({f.styles.length})</span>
          </button>
        ))}
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3" data-testid="font-tiles">
        {fam.styles.map((s) => {
          const cfg = FONT_MAP[s];
          const active = family === fam.id && style === s;
          return (
            <button
              key={s}
              type="button"
              data-testid={`font-tile-${s}`.toLowerCase().replace(/[^a-z0-9-]/g, '-')}
              onClick={() => onPick(fam.id, s)}
              className={`text-left rounded-xl p-4 transition-colors bg-zinc-950 border ${active ? 'border-pink-500 bg-pink-500/10' : 'border-zinc-800 hover:border-pink-500/50'}`}
            >
              <div
                className="text-white text-2xl leading-[1.15] truncate"
                style={cfg ? { fontFamily: cfg.css, fontWeight: cfg.weight } : {}}
              >
                {preview}
              </div>
              <div className="mt-2 flex items-center justify-between text-[10px] uppercase tracking-widest text-zinc-500">
                <span>{s}</span>
                {active && <span className="text-pink-400">Selected</span>}
              </div>
            </button>
          );
        })}
      </div>
    </div>
  );
}
